import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function PageSidebar() {
  const [t] = useTranslation();

  return (
    <aside className="sidebar-widget">
      <section
        id="custom_html-5"
        className="widget_text widget widget_custom_html"
      >
        <h2 className="widget-title">{t("sidebar.follow")}</h2>
        <div className="textwidget custom-html-widget">
          <div className="widget-social">
            <a
              href="https://www.facebook.com/fpebar.me"
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
            >
              <i className="fab fa-facebook-f" />
            </a>
            <a
              href="https://www.instagram.com/fpepbar/"
              target="_blank"
              rel="noopener noreferrer"
              title="Instagram"
            >
              <i className="fab fa-instagram" />
            </a>
            <a
              href="https://www.youtube.com/@fpepbar"
              target="_blank"
              rel="noopener noreferrer"
              title="YouTube"
            >
              <i className="fab fa-youtube" />
            </a>
            <a
              href="https://www.tiktok.com/@fpepbar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Tiktok"
              title="Tiktok"
            >
              <i className="fab fa-tiktok" />
            </a>
            <a
              href="https://www.linkedin.com/school/fpepbar/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on LinkedIn"
              title="LinkedIn"
            >
              <i className="fab fa-linkedin-in" />
            </a>
          </div>
        </div>
      </section>

      <section id="categories-1" className="widget widget_categories">
        <h2 className="widget-title">{t("sidebar.useful")}</h2>
        <ul>
          <li className="cat-item cat-item-16">
            <Link to="/o-fpep">{t("about.fpep")}</Link>
          </li>
          <li className="cat-item cat-item-23">
            <Link to="/akreditacija-fpep">{t("admission.Akreditacija")}</Link>
          </li>
          <li className="cat-item cat-item-18">
            <Link to="/upis">{t("upis.title")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/projekti">{t("saradnja.projekti")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/dom-studenata">{t("studenti.dom")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/galerija">{t("navbar.Gallery")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/novosti">{t("navbar.News")}</Link>
          </li>
        </ul>
      </section>

      <section id="recent-posts-4" className="widget widget_recent_entries">
        <h2 className="widget-title">{t("sidebar.study")}</h2>
        <ul>
          <li>
            <span className="post-date">
              <strong>{t("programs.osnovne")}</strong> <br />
            </span>
            <Link to="/racunovodstvo-finansije-i-bankarstvo">
              {t("osnovne.rfb")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/menadzment">
              {t("osnovne.menadzment")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/pravo-osnovne">
              {t("osnovne.pravo")}
              <br />
            </Link>
          </li>

          <li>
            <span className="post-date">
              <strong>{t("programs.master")}</strong> <br />
            </span>
            <Link to="/poslovna-ekonomija">
              {t("master.poslovnaEkonomija")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/ekonomija-javnog-sektora">
              {t("master.ekonomijaJavnogSektora")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/pravo-master">
              {t("master.pravo")}
              <br />
            </Link>
          </li>

          <li>
            <span className="post-date">
              <strong>{t("programs.specijalisticke")}</strong> <br />
            </span>
            <Link to="/menadzment-javnog-sektora-specijalisticke">
              {t("specijalisticke.mjs")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/menadzment-profitnog-sektora-specijalisticke">
              {t("specijalisticke.mps")}
              <br />
            </Link>
          </li>
        </ul>
      </section>
    </aside>
  );
}

function OCrnojGori() {
  const [t] = useTranslation();

  // CRA-friendly, ali i “ne puca” ako nema process env (fallback na root putanju).
  const youtubeEmbed =
    "https://www.youtube.com/embed/u4iAO81XYPA?start=0&rel=0&modestbranding=1";

  const pageTitle = t("pages.o-crnoj-gori");

  const highlightIcons = [
    "fas fa-water", // more
    "fas fa-mountain", // planine
    "fas fa-landmark", // kultura
    "fas fa-handshake", // partneri / gostoprimstvo
  ];

  const defaultHighlights = [
    {
      title: t("crnagora.h1Title", {
        defaultValue: "More i planine, blizu jedno drugom",
      }),
      text: t("crnagora.h1Text", {
        defaultValue:
          "U kratkom vremenu prelazi se od obale do planinskih predjela – idealno za goste koji žele više doživljaja u jednoj posjeti.",
      }),
    },
    {
      title: t("crnagora.h2Title", {
        defaultValue: "Priroda koja djeluje filmski",
      }),
      text: t("crnagora.h2Text", {
        defaultValue:
          "Jezera, kanjoni, šume i vidikovci – Crna Gora je mala na mapi, ali velika po kontrastima.",
      }),
    },
    {
      title: t("crnagora.h3Title", {
        defaultValue: "Kultura, tradicija i ritam Mediterana",
      }),
      text: t("crnagora.h3Text", {
        defaultValue:
          "Gradovi, događaji i lokalni običaji čine posjetu toplom, autentičnom i lako pamtljivom.",
      }),
    },
    {
      title: t("crnagora.h4Title", {
        defaultValue: "Dobrodošli – posebno ako dolazite kao partner",
      }),
      text: t("crnagora.h4Text", {
        defaultValue:
          "Ova stranica je mini-vodič za naše goste i saradnike: šta da očekujete i gdje da nađete zvanične info.",
      }),
    },
  ];

  const localizedHighlights = t("crnagora.highlights", { returnObjects: true });
  const highlights = Array.isArray(localizedHighlights)
    ? localizedHighlights
    : defaultHighlights;

  const defaultPractical = [
    t("crnagora.tip1", {
      defaultValue:
        "Planirajte posjetu po interesovanjima: obala, stari gradovi, priroda – sve je dostupno, ali vrijedi ostaviti vremena za spontana otkrića.",
    }),
    t("crnagora.tip2", {
      defaultValue:
        "Za dnevne ideje i aktuelne preporuke (rute, događaji, atrakcije) koristite zvanični Montenegro Travel portal.",
    }),
    t("crnagora.tip3", {
      defaultValue:
        "Ako dolazite na akademsku posjetu, spojite program sastanaka sa kratkim obilaskom Bara i okoline – doživljaj bude potpuniji.",
    }),
    t("crnagora.tip4", {
      defaultValue:
        "Najbolji suveniri su iskustva: lokalna hrana, šetnje uz more i pogledi sa vidikovaca. Da, zvuči kao kliše – ali radi.",
    }),
  ];

  const localizedPracticalItems = t("crnagora.practicalItems", {
    returnObjects: true,
  });
  const practicalItems = Array.isArray(localizedPracticalItems)
    ? localizedPracticalItems
    : defaultPractical;

  return (
    <>
      <Navbar />
      <Bredcom title={t("breadcrumb.home")} subtitle={pageTitle} />

      <div className="container">
        <div className="row">
          <div className="col-md-8 pt-80">
            <main className="o-crnoj-gori cg-page" aria-label={pageTitle}>
              {/* HERO */}
              <header className="cg-hero">
                <div className="cg-hero__wrap">
                  <div className="cg-hero__copy">
                    <span className="cg-hero__badge">
                      {t("crnagora.title")}
                    </span>

                    <h2 className="cg-hero__title">
                      {t("crnagora.heroTitle", {
                        defaultValue:
                          "Crna Gora - osjećaj Mediterana, energija planina",
                      })}
                    </h2>

                    <p className="cg-hero__lead">
                      {t("crnagora.heroLead", {
                        defaultValue:
                          "Ovaj mini-vodič je napravljen za naše partnere i goste iz inostranstva: kratak uvod u zemlju, vizuelni doživljaj i praktične smjernice - a za detalje vas vodi zvanični Montenegro Travel portal.",
                      })}
                    </p>

                    <div className="cg-hero__actions">
                      <a
                        className="cg-btn cg-btn--primary"
                        href="#cg-practical"
                      >
                        {t("crnagora.heroCtaPrimary", {
                          defaultValue: "Praktične info",
                        })}
                      </a>

                      <a
                        className="cg-btn cg-btn--ghost"
                        href="https://www.montenegro.travel/en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("crnagora.heroCtaSecondary", {
                          defaultValue: "Montenegro Travel",
                        })}
                      </a>
                    </div>
                  </div>

                  <div className="cg-hero__media">
                    <div className="cg-videoCard">
                      <div className="cg-videoCard__top">
                        <span className="cg-videoCard__label">
                          {t("crnagora.videoTitle", {
                            defaultValue: "Video trailer",
                          })}
                        </span>
                      </div>

                      <iframe
                        className="cg-video"
                        src={youtubeEmbed}
                        title={t("crnagora.videoTitle", {
                          defaultValue: "Video trailer",
                        })}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      />
                    </div>

                    <p className="cg-videoCaption">
                      {t("crnagora.videoCaption", {
                        defaultValue:
                          "Kratak vizuelni utisak: obala, planine, gradovi.",
                      })}
                    </p>
                  </div>
                </div>
              </header>

              {/* HIGHLIGHTS */}
              <section className="cg-section">
                <div className="cg-section__head">
                  <h3 className="cg-section__title">
                    {t("crnagora.highlightsTitle", {
                      defaultValue: "Zašto ljudi zavole Crnu Goru",
                    })}
                  </h3>
                  <p className="cg-section__hint">
                    {t("crnagora.highlightsHint", {
                      defaultValue:
                        "Ovo je “brzi osjećaj” destinacije. Za tačne rute i aktuelne preporuke idi na Montenegro Travel.",
                    })}
                  </p>
                </div>

                <div className="cg-highlights">
                  {highlights.map((item, idx) => (
                    <article className="cg-card" key={`${item.title}-${idx}`}>
                      <div className="cg-card__icon" aria-hidden="true">
                        <i
                          className={
                            highlightIcons[idx % highlightIcons.length]
                          }
                        />
                      </div>
                      <h4 className="cg-card__title">{item.title}</h4>
                      <p className="cg-card__text">{item.text}</p>
                    </article>
                  ))}
                </div>
              </section>

              {/* MAIN PANELS */}
              <section className="cg-section cg-split">
                <article className="cg-panel">
                  <div className="cg-panel__head">
                    <h3 className="cg-panel__title">
                      {t("crnagora.subtitle1")}
                    </h3>
                    <span className="cg-panel__tag">
                      <i className="fas fa-graduation-cap" aria-hidden="true" />{" "}
                      {t("crnagora.tagEducation", {
                        defaultValue: "Study & cooperation",
                      })}
                    </span>
                  </div>

                  <div className="cg-panel__body">
                    <p className="cg-panel__text">{t("crnagora.p3")}</p>
                    <p className="cg-panel__text">{t("crnagora.p5")}</p>

                    <div className="cg-panel__links">
                      <Link to="/erasmus" className="cg-link">
                        {t("saradnja.erasmus")}
                      </Link>
                      <Link to="/projekti" className="cg-link">
                        {t("saradnja.projekti")}
                      </Link>
                    </div>
                  </div>
                </article>

                <article className="cg-panel">
                  <div className="cg-panel__head">
                    <h3 className="cg-panel__title">
                      {t("crnagora.subtitle2")}
                    </h3>
                    <span className="cg-panel__tag">
                      <i className="fas fa-route" aria-hidden="true" />{" "}
                      {t("crnagora.tagTravel", {
                        defaultValue: "Culture & travel",
                      })}
                    </span>
                  </div>

                  <div className="cg-panel__body">
                    <p className="cg-panel__text">{t("crnagora.p6")}</p>
                    <p className="cg-panel__text">{t("crnagora.p7")}</p>
                    <p className="cg-panel__text">{t("crnagora.p8")}</p>
                    <p className="cg-panel__text">{t("crnagora.p9")}</p>
                  </div>
                </article>
              </section>

              {/* PRACTICAL */}
              <section id="cg-practical" className="cg-section">
                <div className="cg-section__head">
                  <h3 className="cg-section__title">
                    {t("crnagora.practicalTitle", {
                      defaultValue: "Praktično: prije nego krenete",
                    })}
                  </h3>
                </div>

                <ul className="cg-list">
                  {practicalItems.map((text, idx) => (
                    <li key={`tip-${idx}`}>{text}</li>
                  ))}
                </ul>
              </section>

              {/* MAP */}
              <section className="cg-section cg-map">
                <div className="cg-section__head">
                  <h3 className="cg-section__title">{t("crnagora.map")}</h3>
                  <p className="cg-section__hint">
                    {t("crnagora.mapHint", {
                      defaultValue:
                        "Zumirajte i istražite regije. Za ideje gdje i kada – Montenegro Travel je “source of truth”.",
                    })}
                  </p>
                </div>

                <div className="cg-map__frame">
                  <iframe
                    title={t("crnagora.map", {
                      defaultValue: "Mapa Crne Gore",
                    })}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1944798.2343435666!2d18.419063780868203!3d42.98688597877416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134deb443b2e2cbb%3A0xa8c75903d7a78af0!2sMontenegro!5e0!3m2!1sen!2s!4v1614853598591!5m2!1sen!2s"
                    width="100%"
                    height="450"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                  />
                </div>
              </section>

              {/* PROMO */}
              <section
                className="cg-promo"
                aria-label={t("crnagora.promotionTitle")}
              >
                <div className="cg-promo__inner">
                  <h3 className="cg-promo__title">
                    {t("crnagora.promotionTitle")}
                  </h3>
                  <p className="cg-promo__text">
                    {t("crnagora.promotionText")}
                  </p>

                  <div className="cg-promo__actions">
                    <a
                      href="https://www.montenegro.travel/en"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cg-btn cg-btn--primary"
                    >
                      {t("crnagora.visitSite")}
                    </a>

                    <Link to="/o-baru" className="cg-btn cg-btn--ghost">
                      {t("pages.o-baru")}
                    </Link>
                  </div>
                </div>
              </section>
            </main>
          </div>

          <div className="col-md-4 pt-110">
            <PageSidebar />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default OCrnojGori;
